import classNames from "classnames";
import i18next from "i18next";
import React, { useCallback, useState } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { useMapContext } from "../../Contexts/MapContext";
import { PopupButton } from "../../Elements/PopupButton";
import { getToken } from "../rest";
import { WidgetInput } from "../Widget/WidgetInput";
import { saveToken } from "./Token";
import "./Authorization.scss";

export const Authorization = (): JSX.Element => {
    const { language, setActiveToken } = useAppContext();
    const { configA } = useMapContext();
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>(null);

    const updateUsername = (event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value);

    const updatePassword = (event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value);

    const login = useCallback(async () => {
        const response = await getToken(configA.endpoints[configA.geotelpa.endpoint], username, password);
        if (response.success) {
            saveToken(response.data);
            setActiveToken(response.data.token);
            setErrorMessage(null);
        } else {
            const errorText =
                response?.data?.error?.error_description?.find((err) => err.language === language)?.description ||
                i18next.t("mapDownload.error");
            setErrorMessage(errorText);
        }
    }, [username, password, errorMessage]);

    return (
        <>
            <div className={classNames("auth-info", { "map-download-error": errorMessage })}>
                <div className="info-text">{errorMessage || i18next.t("mapDownload.authorizeText")}</div>
            </div>
            <WidgetInput
                classname="auth-input"
                value={username}
                onChange={updateUsername}
                placeholder={i18next.t("mapDownload.username")}
            />
            <WidgetInput
                classname="auth-input"
                value={password}
                onChange={updatePassword}
                placeholder={i18next.t("mapDownload.password")}
                isPasswordField={true}
            />

            <div className="authorization-button">
                <PopupButton title={i18next.t("mapDownload.authorize")} onClick={login} loading={false} />
            </div>
        </>
    );
};
